<button (click)="clickCallback(result)">{{buttonText}}</button>
